<template>
	<div class="audioPlayer">
		<div class="row">
			<div style="width: 100%; position: relative;" :id="element_name"></div>
		</div>

		<div class="row audio-info">
			<div class="col-auto">
				Duração: {{ total_time }}
			</div>

			<div class="col-auto">
				Tempo de reprodução: {{ play_time }}
			</div>
		</div>

		<div class="row audio-controls d-flex justify-content-between">
			<div class="col-2 d-flex flex align-items-center">
				<font-awesome-icon v-if="playing" icon="pause" class="pointer info" @click="playPause" />
				<font-awesome-icon v-else         icon="play"  class="pointer info" @click="playPause" />
				<font-awesome-icon icon="stop"    class="pointer info ml-3" @click="stop" />
				<font-awesome-icon icon="retweet" class="pointer info ml-3" :class="( loop ) ? 'active' : ''" @click="toogleLoop" />
			</div>

			<div class="col-4 d-flex align-items-center">
				<label>Velocidade</label>
				<input type="range" class="form-control-range" v-model="speed" @input="wavesurfer.setPlaybackRate(speed)" min="0.5" max="2" step="0.1" value="1">
				<label>{{ speed }}</label>
			</div>

			<div class="col-3 d-flex align-items-center">
				<font-awesome-icon icon="volume-mute" class="pointer info" @click="updateVol(0)" />
				<input type="range" class="form-control-range" v-model="volume" @input="wavesurfer.setVolume(volume)" min="0" max="1" step="0.01" value="1">
				<font-awesome-icon icon="volume-up" class="pointer info" @click="updateVol(1)" />
			</div>
		</div>
	</div>
</template>

<script>
	import WaveSurfer    from 'wavesurfer.js'
	import CursorPlugin  from 'wavesurfer.js/dist/plugin/wavesurfer.cursor.js'
	import RegionsPlugin from 'wavesurfer.js/src/plugin/regions.js'

	export default {
		name: "Player",
		props: ["audio_hash", "name"],

		data() { return {
			wavesurfer : null,
			playing: false,
        	loop   : false,
		    volume : 1,
		    speed  : 1,

		    total_time: "00:00:00",
		    play_time : "00:00:00",

		    ctrl_key: false,
		}},

		created() { document.addEventListener('keydown', this.keybord_control ) },

		beforeDestroy() { 
			if (this.wavesurfer) this.wavesurfer.destroy()
			document.removeEventListener('keydown', this.keybord_control )
		},

		computed: {
			element_name() { return this.name ? this.name : 'waveform' }
		},

		watch: {
			audio_hash(next) {
				if ( next != null ) {
					if ( this.wavesurfer )
						this.wavesurfer.destroy()

					this.load( new Audio(next) )
				}
			}
		},

	    methods: {
	    	load(audio) {
	    		this.wavesurfer = WaveSurfer.create({
	                container: document.querySelector(`#${this.element_name}`),
	                waveColor: '#0E8F84',
	                progressColor: '#23514C',
	                backend: 'MediaElement',
					normalize: true,
					height: '64',
	                plugins: [
	                    CursorPlugin.create({
	                        opacity: 0.6,
	                        showTime: true,
	                        customShowTimeStyle: {
	                            'background-color': '#000',
	                            color: '#fff',
	                            'font-size': '12px'
	                        }
	                    }),

	                    RegionsPlugin.create({
					    	dragSelection: {
				                slop: 5
				            }
					    })
	                ]
	            })

	            this.wavesurfer.load( audio )

	            this.wavesurfer.on( 'ready',        () => this.total_time = this.get_time(this.wavesurfer.getDuration()) )
	            this.wavesurfer.on( 'audioprocess', () => this.play_time  = this.get_time(this.wavesurfer.getCurrentTime()) )
	            this.wavesurfer.on( 'finish',       () => this.looping() )
	    	},

	    	get_time(payload) {
	    		let time = new Date(null)
	    		time.setSeconds(payload)
	    		return time.toISOString().substr(11, 8)
	    	},

	        playPause() {
	            this.wavesurfer.playPause()
	            this.playing = this.wavesurfer.isPlaying()
	        },

	        stop() {
	        	this.wavesurfer.stop()
	        	this.playing   = false
	        	this.play_time = "00:00:00"
	        },

	        updateVol(payload) {
	            this.wavesurfer.setVolume(payload)
	            this.volume = payload
	        },

	        toogleLoop()  {
	            this.loop = !this.loop
	        },

	        looping() {
	        	if ( this.loop == true ) this.wavesurfer.play()
                else this.stop()
	        },

	        keybord_control(e) {
				if ( e.keyCode == 17 ) this.ctrl_key = true;
			    
			    else if ( e.keyCode == 32 && this.ctrl_key === true ) {
			        this.ctrl_key = false
			        this.playPause()
			    }

			    else this.ctrl_key = false
	        }
	    },
	}
</script>